$(document).on('turbolinks:load', () => {
  setTimeout(() => {
    $('.alert').fadeOut();
  }, 3000);
});
